import { safeWindow } from '../safeWindow/safeWindow';

const MAIN_SCRIPT_SELECTOR = 'script[src*="/static/js/main."]';
const BUILD_HASH_PATTERN = /main\.([a-f0-9]+)\.js/i;

const bootedAt = Date.now();

/**
 * The hash of the loaded main bundle identifies the build this tab actually runs.
 * Sentry's `release` comes from package.json, which is pinned, so it cannot tell a
 * tab running a stale shell from a fresh one — and a stale shell 404s on every lazy
 * chunk the current build no longer ships.
 */
const getBuildHash = (): string | undefined => {
  try {
    const src = safeWindow()
      ?.document
      ?.querySelector<HTMLScriptElement>(MAIN_SCRIPT_SELECTOR)
      ?.src;

    return src ? BUILD_HASH_PATTERN.exec(src)?.[1] : undefined;
  } catch {
    return undefined;
  }
};

// A type alias, not an interface: Sentry's `Context` is an index-signature type
// and only aliases get an implicit index signature.
export type AppShellInfo = {
  buildHash?: string;
  bootedAt: string;
  ageMinutes: number;
};

export const getAppShellInfo = (): AppShellInfo => ({
  buildHash: getBuildHash(),
  bootedAt: new Date(bootedAt)
    .toISOString(),
  ageMinutes: Math.round((Date.now() - bootedAt) / 60000),
});
